import { render, staticRenderFns } from "./itcPaperManager.vue?vue&type=template&id=698d837a"
import script from "./itcPaperManager.vue?vue&type=script&lang=js"
export * from "./itcPaperManager.vue?vue&type=script&lang=js"
import style0 from "./itcPaperManager.vue?vue&type=style&index=0&id=698d837a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports